<template>
  <div class="bg-white m-3 rounded-md p-3">
    <div class="bg-white m-2 rounded-md">
      <div class="">
        <el-tabs type="border-card">
          <el-tab-pane
            v-for="(tab, index) in filteredTabs"
            :key="index"
            :label="tab.name"
          >
            <transition name="fade">
              <div
                v-if="create_error"
                class="p-1 text-center text-sm w-full bg-yellow-200"
              >
                {{ create_error }}
              </div>
            </transition>
            <transition name="fade">
              <div
                v-if="create_success"
                class="p-1 text-center text-sm w-full bg-green-200"
              >
                {{ create_success }}
              </div>
            </transition>
            <div v-if="index === 0">
              <div class="flex justify-between items-center p-2">
                <!-- search -->
                <input
                  v-model="searchInput"
                  type="search"
                  placeholder="Start typing to search..."
                  class="bg-gray-200 w-52 py-1 rounded-md"
                  @change="handleInputChange"
                />
                <button
                    @click="showAssignTechnology= true"
                    class="bg-primary text-white rounded-full px-3 py-1 text-sm"
                >
                 Assign Technology
                </button>
              </div>
              <ve-table :columns="columns" :tableData="tableData"> </ve-table>
              <p
                class="text-center p-2"
                v-if="
                  tableData.length === 0 &&
                  getUserRole.toLowerCase() === 'hrmanager'
                "
              >
                No Assets
              </p>
            </div>

            <div
              v-if="index === 1 && getUserRole.toLowerCase() === 'hrmanager'"
              class="mt-2"
            >


            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  <assign-technologies
      :showAssignTechnology="showAssignTechnology"
      @close="showAssignTechnology = false"
      @closeOnSuccess="handleCloseOnSuccess"
  />
  </div>
</template>

<script>
import decryptData from "@/utils/decrypt";
import axios from "axios";
import assignTechnologies from "@/components/employees/modals/assignTechnologies";

import { mapGetters } from "vuex";

export default {
  name: "Assets",
  components: {
    assignTechnologies
  },
  data() {
    return {
      activeName: "",
      virtualScrollOption: {
        enable: true,
      },
      assetIds: [],
      showAddAsset: false,
      currentEmployeeAssets: [],
      title: "Manage Employee Assets",
      searchInput: "",
      searchInputForAssignedAssets: "",
      searchInputForAvailableAssets: "",
      create_error: null,
      create_success: null,
      assignedAssets: [],
      availableAssests: [],
      activeAssetType: "Available",
      showAssignTechnology: false,
      tabs: [
        {
          name: "Assigned Technologies",
          route: "my-assets",
        },
      ],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "AssetNo",
          key: "assetno",
          title: "Asset No",
          align: "left",
          headerAlign: "left",
        },

        {
          field: "Description",
          key: "description",
          title: "Description",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "Employee",
          key: "Employee",
          title: "Employee",
          renderBodyCell: ({ row }) =>
            decryptData(row.Employee, this.$decryptionKey),
          align: "left",
          headerAlign: "left",
        },

        {
          field: "AssetStatus",
          key: "status",
          title: "status",
        },
      ],
      tableData: [],
      availableAssetsColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "AssetNo",
          key: "assetno",
          title: "Asset No",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "SerialNumber",
          key: "SerialNumber",
          title: "Serial Number",
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ row }) =>
            row.SerialNumber ? row.SerialNumber : "....",
        },
        {
          field: "Name",
          key: "name",
          title: "Name",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "Description",
          key: "description",
          title: "Description",
          align: "left",
          headerAlign: "left",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          field: "AssetType",
          key: "AssetType",
          title: "Asset Type",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "AssetStatus",
          key: "AssetStatus",
          title: "Asset Status",
          align: "center",
          headerAlign: "left",
        },

        {
          field: "Assigned",
          key: "Assigned",
          title: "Assigned",
          renderBodyCell: ({ row }) => (row.Assigned ? "Yes" : "No"),
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                {!row.Assigned ? (
                  <button
                    class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                    style="boder-radius: 0 !important"
                    onClick={() => this.assign(row)}
                  >
                    Assign
                  </button>
                ) : null}
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      assignedAssetsColumn: [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: 50,
          align: "center",
        },
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "AssetNo",
          key: "assetno",
          title: "Asset No",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "SerialNumber",
          key: "SerialNumber",
          title: "Serial Number",
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ row }) =>
            row.SerialNumber ? row.SerialNumber : "....",
        },
        {
          field: "Name",
          key: "name",
          title: "Name",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "Description",
          key: "description",
          title: "Description",
          align: "left",
          headerAlign: "left",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          field: "AssetType",
          key: "AssetType",
          title: "Asset Type",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "AssetStatus",
          key: "AssetStatus",
          title: "Asset Status",
          align: "center",
          headerAlign: "left",
        },

        {
          field: "Employee",
          key: "Employee",
          title: "Employee",
          renderBodyCell: ({ row }) =>
            decryptData(row.Employee, this.$decryptionKey),
          align: "left",
          headerAlign: "center",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.unassign(row)}
                >
                  Unassign
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      tableData2: [],
      checkboxOption: {
        // row select change event
        selectedRowChange: ({ isSelected, selectedRowKeys }) => {
          if (isSelected) {
            this.assetIds = selectedRowKeys;
          } else {
            this.assetIds = [];
          }
        },
        // selected all change event
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          if (isSelected) {
            this.assetIds = selectedRowKeys;
          } else {
            this.assetIds = [];
          }
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserRole",
      "getCurrentEmployeeId",
    ]),
    filteredTabs() {
      if (this.getUserRole.toLowerCase() === "hrmanager") {
        return this.tabs;
      } else {
        return this.tabs.filter((tab) => tab.name !== "Assets Management");
      }
    },

    filteredAvailableAssetsTableData() {
      if (!this.searchInputForAvailableAssets) {
        // If no search input is provided, return the full tableData

        return this.availableAssests;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower =
          this.searchInputForAvailableAssets.toLowerCase();
        return this.availableAssests.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },

    filteredAssignedAssetsTableData() {
      if (!this.searchInputForAssignedAssets) {
        // If no search input is provided, return the full tableData
        return this.assignedAssets;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower =
          this.searchInputForAssignedAssets.toLowerCase();
        return this.assignedAssets.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
  },
  created() {
    this.getMyAssets();
    this.getOrganizationAssets();
    this.getAssignedAssets();
  },

  methods: {
    handleCloseOnSuccess() {
      this.showAssignTechnology = false
    },
    showConfirmationDiag() {
      this.$confirm(
        "You are about to unassign the selected assets. Do you want to proceed?",
        "Unassign Assets"
      )
        .then((response) =>
          response === "confirm" ? this.unassignBulk(this.assetIds) : null
        )
        .catch((error) => console.log(error));
    },
    handleInputChange() {},
    handleClose() {
      this.showAddAsset = false;
    },
    reloadLocal() {
      this.getMyAssets();
      this.getOrganizationAssets();
      this.getAssignedAssets();
    },
    // /{organization}/employee/{EmployeeId}/assets/v1/assigned
    getMyAssets() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/assets/${this.$ApiVersion}/assigned`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.currentEmployeeAssets = response.data.Data;
              this.tableData = response.data.Data;
              //console.log(this.currentEmployeeAssets);
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.get_error = null;
            }, 2000);
          }
        );
    },
    // /{organization}/asset/v1/assign
    assign(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      let info = {
        AssetId: row.Id,
        EmployeeId: this.getCurrentEmployeeId,
      };
      axios
        .post(
          `${this.getOrganization}/asset/${this.$ApiVersion}/assign`,
          JSON.stringify(info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              setTimeout(() => {
                this.create_success = null;
                // this.close();
                this.reloadLocal();
                // this.reload();
              }, 2000);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    // /{organization}/asset/v1/unassign
    unassign(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
        data: {
          Id: row.Id,
        },
      };

      axios
        .delete(
          `${this.getOrganization}/asset/${this.$ApiVersion}/unassign`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              setTimeout(() => {
                this.create_success = null;
                // this.close();
                this.reloadLocal();
                // this.reload();
              }, 2000);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    // /{organization}/asset/v1/unassign
    unassignBulk(ids) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
        data: {
          Id: "",
        },
      };
      ids.forEach((id) => {
        options.data.Id = id;
        axios
          .delete(
            `${this.getOrganization}/asset/${this.$ApiVersion}/unassign`,
            options
          )
          .then(
            (response) => {
              this.loading = false;
              if (response.data.StatusCode == 200) {
                this.create_success = response.data.StatusMessage;
                setTimeout(() => {
                  this.create_success = null;
                  // this.close();
                  this.reloadLocal();
                  // this.reload();
                }, 2000);
              } else {
                this.create_error = response.data.StatusMessage;
              }
            },
            (error) => {
              this.loading = false;
              this.create_error = error.message;
            }
          );
      });
    },

    // /{organization}/asset/v1/request
    getOrganizationAssets() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.currentEmployeeAssets = response.data.Data;
              this.availableAssests = response.data.Data.filter(
                (asset) => asset.Assigned === false
              );
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.get_error = null;
            }, 2000);
          }
        );
    },

    // /{organization}/asset/assigned/v1/request
    async getAssignedAssets() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      this.loading = true;
      try {
        const response = await axios.get(
          `${this.getOrganization}/asset/assigned/${this.$ApiVersion}/request`,
          options
        );
        this.loading = false;
        if (response.data.StatusCode === 200) {
          this.assignedAssets = response.data.Data;
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },
  },
};
</script>
<style>
.el-collapse-item__header {
  padding-left: 1rem !important;
  font-weight: bold !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity)) !important;
}
</style>
